export default {"src":"/_next/static/media/Play.b248c098.svg","height":183,"width":183,"blurWidth":0,"blurHeight":0};